/* eslint-disable no-nested-ternary */
import React, {useCallback, useState} from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import InputContainer from 'components/InputContainer';
import Folder from 'assets/svgs/common/folder.svg';
import CloudImage from 'assets/svgs/file-upload/cloud.svg';
import AddFolderIcon from 'assets/svgs/file-upload/upload-folder.svg';
import File from 'assets/svgs/file-upload/file.svg';

import ClearIcon from 'assets/svgs/actions/clear.svg';
import AddIcon from 'assets/svgs/actions/add-gray.svg';

import {useDropzone} from 'react-dropzone';
import {makeSelectBasicUser} from 'reducers/selectors/userSelectors';
import {useSelector} from 'react-redux';
import {createFolder} from 'utils/fetch';
import SingleFile from './SingleFile';
import messages from './messages';
import './style.scss';

const basicUserSelector = makeSelectBasicUser();

const FileUpload = ({
  onClose,
  folderState,
  onAddFolder,
  selected,
  categoryType,
  breadcrumb,
  onFileUpload,
}) => {
  const userDetails = useSelector(basicUserSelector);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploaded, setUploaded] = useState(0);
  const [localSelected, setLocalSelected] = useState(null);

  const [folderName, setFolderName] = useState({name: '', isValid: null});

  const fileState = {
    Select: 'SELECT',
    Uploading: 'UPLOADING',
    Uploaded: 'UPLOADED',
    Server: 'SERVER',
    AddFolder: 'ADDFOLDER',
    uploadFolder: 'FOLDER',
    uploadFile: 'FILE',
  };

  const [currentSection, setCurrentSection] = useState(fileState.AddFolder);

  const createFolderAndUploadFiles = async (obj, filters, acceptedFiles) => {
    const folder = await createFolder({
      authToken: userDetails.authToken,
      filters,
      details: obj,
    });

    setLocalSelected(folder);

    setSelectedFiles(acceptedFiles);
    setCurrentSection(fileState.Uploading);
  };

  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file.webkitRelativePath) {
      const fileFolder = file.webkitRelativePath.split('/')[0];
      const obj = {name: fileFolder};
      const filters = {};
      if (selected) {
        filters.folderId = selected._id;
      }
      if (breadcrumb.length > 0) {
        filters.parentId = breadcrumb[0]._id;
      } else if (selected) {
        filters.parentId = selected._id;
      }
      obj.categoryType = 'DOCUMENTS';
      createFolderAndUploadFiles(obj, filters, acceptedFiles);
    } else {
      setCurrentSection(fileState.Uploading);
    }

    setUploaded(0);
    setSelectedFiles(acceptedFiles);
  }, []);

  const {getRootProps, getInputProps} = useDropzone({
    onDrop,
    accept: 'image/jpeg,image/webp, image/png, image/svg+xml, application/pdf',
  });

  const renderDropzone = () => (
    <div className="featured-img-uploaded upload-modal w-100">
      <div className="uploaded-img d-flex justify-content-center">
        <div {...getRootProps()} className="w-100">
          {fileState.uploadFolder === currentSection ? (
            <input {...getInputProps()} directory="" webkitdirectory="" />
          ) : (
            <input {...getInputProps()} />
          )}

          <div className="d-flex justify-content-center align-items-center flex-column h-100">
            <img alt="test" src={CloudImage} />
            <p className="px-1 mt-2">
              Drag and Drop or <span className="text-gold">Browse</span> to
              upload
            </p>
          </div>
        </div>
      </div>
    </div>
  );

  const renderUploading = () => (
    <div className="d-flex w-100 uploading-section flex-column bg-white">
      <div className="w-100 py-3 bg-gray4 px-4 border-bottom">
        {`Uploading ${selectedFiles.length} files`}
      </div>

      {selectedFiles.map((f) => (
        <React.Fragment key={f.lastModified + f.name}>
          <SingleFile
            parentId={
              breadcrumb.length > 0
                ? breadcrumb[0]._id
                : selected
                ? selected._id
                : undefined
            }
            file={f}
            basicUser={userDetails}
            categoryType={categoryType}
            folderId={
              selected
                ? selected._id
                : localSelected
                ? localSelected._id
                : undefined
            }
            onUpload={(file) => {
              onFileUpload(!localSelected ? file : null);
              setUploaded((old) => {
                if (
                  parseInt(old, 10) + 1 === selectedFiles.length ||
                  uploaded === selectedFiles.length
                ) {
                  onClose(localSelected);
                }
                return parseInt(old, 10) + 1;
              });
            }}
          />
        </React.Fragment>
      ))}
    </div>
  );

  const AddFolder = () => (
    <div className="d-flex w-100 flex-column add-folder-container">
      <p>{messages.addNewFolder}</p>
      <div>
        <InputContainer
          type="text"
          value={folderName.name}
          handleChange={(event) => {
            const newFolderName = {...folderName};
            newFolderName.name = event.target.value;
            setFolderName(newFolderName);
          }}
          rest={{
            onKeyDown: (e) => {
              if (e.key === 'Enter' && folderName.name) {
                onAddFolder(folderName.name);
              }
            },
          }}
          inputClass="form-control"
        />
      </div>
      <div className="d-flex w-100 mt-2">
        <button type="button" className="cat-delete" onClick={onClose}>
          <img src={ClearIcon} alt="" className="mr-2" />
          Cancel
        </button>
        <button
          type="button"
          disabled={folderState.submitting}
          className="ml-4 cat-delete"
          onClick={() => {
            if (folderName.name) {
              onAddFolder(folderName.name);
            }
          }}
        >
          <img src={AddIcon} alt="" className="mr-2" />
          Add Folder
        </button>
      </div>
    </div>
  );

  const renderSections = () => {
    switch (currentSection) {
      case fileState.AddFolder:
        return AddFolder();
      case fileState.uploadFile:
      case fileState.uploadFolder:
        return renderDropzone();
      case fileState.Uploading:
        return renderUploading();
      default:
        return null;
    }
  };
  return (
    <div className="featured-img-popup">
      <div className="overlay"></div>

      <div className="box-popup d-flex justify-content-center align-items-center">
        <OutsideClickHandler
          onOutsideClick={() => {
            onClose();
          }}
        >
          <>
            <div className="content-popup small">
              <div className="d-flex">
                {currentSection !== fileState.Uploading && (
                  <div className="tab-nav position-relative">
                    <ul
                      className="nav nav-pills m-0"
                      id="pills-tab"
                      role="tablist"
                    >
                      <li className="nav-item">
                        <a
                          className={`nav-link  ${
                            currentSection === fileState.AddFolder
                              ? 'active'
                              : ''
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            if (currentSection === fileState.Uploading) return;

                            setCurrentSection(fileState.AddFolder);
                          }}
                          data-toggle="pill"
                          href="#ss"
                          role="tab"
                          aria-controls="pills-upload-logo"
                          aria-selected="true"
                        >
                          <img alt="" className="mr-2" src={Folder} />
                          <span className="tab-text">Add Folder</span>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className={`nav-link  ${
                            currentSection === fileState.uploadFolder
                              ? 'active'
                              : ''
                          }`}
                          data-toggle="pill"
                          href="#ss"
                          onClick={(e) => {
                            e.preventDefault();
                            if (currentSection === fileState.Uploading) return;
                            setCurrentSection(fileState.uploadFolder);
                          }}
                          role="tab"
                          aria-controls="pills-select-logo"
                          aria-selected="false"
                        >
                          <img className="mr-2" alt="" src={AddFolderIcon} />
                          <span className="tab-text"> Upload folder </span>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className={`nav-link  ${
                            currentSection === fileState.uploadFile
                              ? 'active'
                              : ''
                          }`}
                          data-toggle="pill"
                          href="#r"
                          onClick={(e) => {
                            e.preventDefault();
                            if (currentSection === fileState.Uploading) return;
                            setCurrentSection(fileState.uploadFile);
                          }}
                          role="tab"
                          aria-controls="pills-select-logo"
                          aria-selected="false"
                        >
                          <img className="mr-2" alt="" src={File} />
                          <span className="tab-text"> Upload file</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                )}
                <div className="tab-content file-tabs" id="pills-tabContent">
                  <div
                    className={`tab-pane d-flex h-100 justify-content-center align-items-center ${
                      currentSection === fileState.Uploading ? '' : 'px-4'
                    }`}
                    id="pills-upload-logo"
                    role="tabpanel"
                    aria-labelledby="pills-upload-logo-tab"
                  >
                    {renderSections()}
                  </div>
                </div>
              </div>
            </div>
          </>
        </OutsideClickHandler>
      </div>
    </div>
  );
};

export default FileUpload;
